var _templateObject, _templateObject2, _templateObject3, _templateObject4;

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }

function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }

function _taggedTemplateLiteral(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

// eslint-disable-next-line no-unused-vars
import { gql, ApolloClient } from '@apollo/client';
var CART_CREATE_MUTATION = gql(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  mutation createCart($input: CartInput!) {\n    cartCreate(input: $input) {\n      cart {\n        id\n        checkoutUrl\n        cost {\n          checkoutChargeAmount {\n            amount\n            currencyCode\n          }\n          subtotalAmount {\n            amount\n            currencyCode\n          }\n          totalTaxAmount {\n            amount\n            currencyCode\n          }\n          totalTaxAmountEstimated\n        }\n        attributes {\n          key\n          value\n        }\n        discountAllocations {\n          discountedAmount {\n            amount\n            currencyCode\n          }\n        }\n        lines(first: 10) {\n          edges {\n            node {\n              id\n              quantity\n              merchandise {\n                ...on ProductVariant {\n                  id\n                  title\n                  image {\n                    url\n                  }\n                  sku\n                  priceV2 {\n                    amount\n                    currencyCode\n                  }\n                  product {\n                    title\n                  }\n                }\n              }\n              sellingPlanAllocation {\n                sellingPlan {\n                  id\n                }\n              }\n              attributes {\n                key\n                value\n              }\n              discountAllocations {\n                discountedAmount {\n                  amount\n                  currencyCode\n                }\n              }\n            }\n          }\n        }\n      }\n      userErrors {\n        code\n        message\n        field\n      }\n    }\n  }\n"]))); // eslint-disable-next-line no-unused-vars
// const CART_UPDATE_BUYER_MUTATION = gql`mutation updateBuyer($id: ID!, $buyerInfo: CartBuyerIdentityInput!) {
//   cartBuyerIdentityUpdate(cartId: $id, buyerIdentity: $buyerInfo) {
//     cart {
//
//     }
//   }
// }`;

var CART_FRAGMENT = gql(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["fragment CartInfo on Cart {\n  id\n  attributes {\n    key\n    value\n  }\n  deliveryGroups(first: 5) {\n    edges {\n      node {\n        id\n        deliveryAddress {\n          id\n          name\n          firstName\n          lastName\n          address1\n          address2\n          city\n          countryCodeV2\n          provinceCode\n          zip\n        }\n        deliveryOptions {\n          code\n          estimatedCost {\n            amount\n            currencyCode\n          }\n          title\n          description\n          deliveryMethodType\n        }\n      }\n    }\n  }\n  lines(first: 10) {\n    edges {\n      node {\n        id\n        quantity,\n        merchandise {\n          ... on ProductVariant {\n            id\n            sku\n            requiresShipping\n            sellingPlanAllocations(first: 10) {\n              nodes {\n                checkoutChargeAmount {\n                  amount\n                  currencyCode\n                }\n                priceAdjustments {\n                  unitPrice {\n                    amount\n                    currencyCode\n                  }\n                  compareAtPrice {\n                    amount\n                    currencyCode\n                  }\n                  perDeliveryPrice {\n                    amount\n                    currencyCode\n                  }\n                  price {\n                    amount\n                    currencyCode\n                  }\n                }\n                sellingPlan {\n                  id\n                  name\n                  description\n                }\n              }\n            }\n          }\n        }\n      }\n    }\n  }\n}"])));
var CART_QUERY = gql(_templateObject3 || (_templateObject3 = _taggedTemplateLiteral(["\n  ", "\n  query fetchCart($id: ID!) {\n  cart(id: $id) {\n    ...CartInfo\n  }\n}"])), CART_FRAGMENT); // eslint-disable-next-line no-unused-vars

var CART_UPDATE_BUYER_MUTATION = gql(_templateObject4 || (_templateObject4 = _taggedTemplateLiteral(["\n  ", "\n  mutation updateCartBuyer($cartId: ID!, $input: CartBuyerIdentityInput!) {\n    cartBuyerIdentityUpdate(cartId: $cartId, buyerIdentity: $input) {\n      cart {\n        ...CartInfo\n      }\n      userErrors {\n        code\n        field\n        message\n      }\n    }\n  }\n"])), CART_FRAGMENT);
/**
 * @typedef {Object} CartBuyerIdentityInput
 * @property {string|null} countryCode
 * @property {string|null} customerAccessToken
 * @property {string|null} email
 * @property {string|null} phone
 */

/**
 * @typedef {Object} CartLineInput
 * @property {Array.<AttributeInput>} attributes
 * @property {string} merchandiseId
 * @property {number} quantity
 * @property {string|null|undefined} sellingPlanId
 */

/**
 * @typedef {Object} CartInput
 * @property {Array.<AttributeInput>} attributes
 * @property {CartBuyerIdentityInput|null|undefined} buyerIdentity
 * @property {string[]|null|undefined} discountCodes
 * @property {Array.<CartLineInput>} lines
 * @property {string|null|undefined} note
 */

/**
 * Creates a cart with the specified line items
 * @param {ApolloClient} client
 * @param {CartInput} input
 * @returns {Promise<*>}
 */

export function mutateCreateCart(_x, _x2) {
  return _mutateCreateCart.apply(this, arguments);
}
/**
 * Queries a Storefront API cart by id
 * @param {ApolloClient} client
 * @param {string} id - GID in the format gid://shopify/Cart/<numeric-id>
 * @return {Promise<*>}
 */

function _mutateCreateCart() {
  _mutateCreateCart = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(client, input) {
    var result, _result$data$cartCrea, cart, userErrors, _ref, id, checkoutUrl, lines;

    return regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            _context.next = 2;
            return client.mutate({
              mutation: CART_CREATE_MUTATION,
              variables: {
                input: input
              }
            });

          case 2:
            result = _context.sent;
            _result$data$cartCrea = result.data.cartCreate, cart = _result$data$cartCrea.cart, userErrors = _result$data$cartCrea.userErrors;
            _ref = cart || {}, id = _ref.id, checkoutUrl = _ref.checkoutUrl, lines = _ref.lines;
            console.debug('cart create result', result);

            if (!(typeof id === 'undefined')) {
              _context.next = 9;
              break;
            }

            console.error('Failed to create cart', {
              userErrors: userErrors
            });
            throw new Error("Failed to create cart: ".concat(userErrors.reduce(function (str, err) {
              return "".concat(str, "\n").concat(err.message);
            }, '')));

          case 9:
            cart.lines = lines.edges.map(function (line) {
              return line.node;
            });
            return _context.abrupt("return", {
              id: id,
              checkoutUrl: checkoutUrl,
              lines: cart.lines,
              cart: cart
            });

          case 11:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));
  return _mutateCreateCart.apply(this, arguments);
}

export function queryCart(_x3, _x4) {
  return _queryCart.apply(this, arguments);
}

function _queryCart() {
  _queryCart = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2(client, id) {
    var result, _result$data, _result$data$cart, cart, _result$errors, errors;

    return regeneratorRuntime.wrap(function _callee2$(_context2) {
      while (1) {
        switch (_context2.prev = _context2.next) {
          case 0:
            _context2.next = 2;
            return client.query({
              query: CART_QUERY,
              variables: {
                id: id
              }
            });

          case 2:
            result = _context2.sent;
            _result$data = result.data;
            _result$data = _result$data === void 0 ? {} : _result$data;
            _result$data$cart = _result$data.cart, cart = _result$data$cart === void 0 ? null : _result$data$cart, _result$errors = result.errors, errors = _result$errors === void 0 ? [] : _result$errors;
            console.debug('Cart query result', result);

            if (!(errors && errors.length > 0)) {
              _context2.next = 10;
              break;
            }

            console.error('Failed to query cart', {
              errors: errors
            });
            throw new Error("Failed to create cart: ".concat(errors.reduce(function (str, err) {
              return "".concat(str, "\n").concat(err.message);
            }, '')));

          case 10:
            return _context2.abrupt("return", cart);

          case 11:
          case "end":
            return _context2.stop();
        }
      }
    }, _callee2);
  }));
  return _queryCart.apply(this, arguments);
}